import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { formatEntityId } from '../../../../helpers';
import { FORTA_WHITE } from '../../../../utils/colors';
import {
  QUESTIONNAIRE_HEADER_CONTAINER_SX,
  QUESTIONNAIRE_HEADER_DESKTOP_GRID_SX,
  QUESTIONNAIRE_HEADER_FIELD_LABEL_SX,
  QUESTIONNAIRE_HEADER_FIELD_ROW_SX,
  QUESTIONNAIRE_HEADER_FIELD_VALUE_SX,
  QUESTIONNAIRE_HEADER_MOBILE_ID_WRAPPER_SX,
  QUESTIONNAIRE_HEADER_TITLE_SX,
} from '../styles';

import type { QuestionnaireHeaderInfoProps } from '../types';

function Field({ label, value }: { label: string; value: string }) {
  return (
    <Box sx={QUESTIONNAIRE_HEADER_FIELD_ROW_SX}>
      <Typography sx={QUESTIONNAIRE_HEADER_FIELD_LABEL_SX}>{label}</Typography>
      <Typography sx={QUESTIONNAIRE_HEADER_FIELD_VALUE_SX}>{value}</Typography>
    </Box>
  );
}

export default function QuestionnaireHeaderInfo({
  title,
  pageId,
  pageIdPrefix,
  created,
  author,
  child,
}: QuestionnaireHeaderInfoProps) {
  const { t } = useTranslation('header');
  const formattedId = pageId ? formatEntityId(String(pageId), pageIdPrefix) : '';

  return (
    <Box sx={QUESTIONNAIRE_HEADER_CONTAINER_SX}>
      <Typography
        variant="h2"
        fontSize={{ xs: 18, sm: 26, md: 32 }}
        lineHeight={{ xs: 1.2, sm: 1.6, md: 1.5 }}
        fontWeight="bold"
        color={FORTA_WHITE}
        textAlign="left"
        sx={QUESTIONNAIRE_HEADER_TITLE_SX}
      >
        {title}
      </Typography>
      {formattedId && (
        <Box sx={QUESTIONNAIRE_HEADER_MOBILE_ID_WRAPPER_SX}>
          <Field label={t('id')} value={formattedId} />
        </Box>
      )}
      <Box sx={QUESTIONNAIRE_HEADER_DESKTOP_GRID_SX}>
        {formattedId && <Field label={t('id')} value={formattedId} />}
        {author && <Field label={t('author')} value={author} />}
        {created && <Field label={t('created')} value={created} />}
        {child && <Field label={t('child')} value={child} />}
      </Box>
    </Box>
  );
}
